import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./education.css";

import logo2 from "../../../assets/images/logo2.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from "../Stepper";
import { useCookies } from "../../../hooks/useCookies";
import * as userActions from "../../../actions/user";
import * as masterConstantActions from "../../../actions/masterConstant";

export const Education = () => {
  const isFetched = useRef(false);
  const navigate = useNavigate();

  const { getCookie } = useCookies();
  const token = getCookie("token");

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessege] = useState("");

  const [studiesList, setStudiesList] = useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    if (!token) return;
    getConstantStudies();
    fetchUserStudies();
  }, [token, selectedOption]);

  const getConstantStudies = async () => {
    const response = await masterConstantActions.getConstantStudies();
    if (response.status && response.data.length > 0) {
      setStudiesList(response.data);
    }
  };

  const fetchUserStudies = async () => {
    const response = await userActions.getUserStudies();
    setSelectedOption(response?.studies?.[0]?.id);
  };

  const goTojobTitle = () => {
    setLoading(false)
    navigate("/jobtitle");
  };

  async function saveEducation() {
    if (!selectedOption) {
      setErrorMessege("*Please make a selection");
      return;
    }

    setLoading(true)
    try {
      await userActions.UpdateUserStudies({ id: selectedOption });
      goTojobTitle();
    } catch (error) {
      setErrorMessege("*An error occurred");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="education-container">
      <div className="education-bg">
        <Image
          className="responsive-bg"
          src={responsivebg}
          alt="Background"
        ></Image>
      </div>
      <Container className="education-main">
        <Container className="education-content">
          <Container className="logo-progressbar9">
            <Container className="logo-arrow9">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
                alt="Back Arrow"
              />
              <Image
                src={logo2}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="Education" />
          </Container>
          <div className="container-div">
            <Container className="education-details">
              <div className="container-child1">
                <div className="your-education">
                  <Container className="education-text">
                    <p>What’s the highest level of education you’ve attained?</p>
                  </Container>

                  <Container className='all-education'>
                    <div className="row mt-3">
                      {studiesList.map((study) => (
                        <div
                          key={study.id}
                          onClick={() => setSelectedOption(study.id)}
                          className="col-6 sub-inner-div"
                          style={{
                            backgroundColor: selectedOption === study.id ? "#F7ECFF" : "transparent",
                            marginRight: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {study.name}
                        </div>
                      ))}
                    </div>
                    {errorMessage && (
                      <p
                        className="text-danger error-message"
                        style={{
                          marginLeft: "10px",
                          marginTop: "-10px",
                        }}
                      >
                        {errorMessage}
                      </p>
                    )}
                  </Container>
                </div>
              </div>
            </Container>
          </div>
          <div className="d-flex justify-content-center next-btn">
            <button
              type="submit"
              className="global-next-bottom-fix-btn"
              onClick={saveEducation}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                "Next"
              )}
            </button>
          </div>

        </Container>
      </Container>
    </div>
  );
};
